import axiosInstance from "./axiosInstance";

const purchaseService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/purchases/create', payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    save: async (payload) => {
        try {
            const response = await axiosInstance.post('/purchases/save', payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchAllPatients: async () => {
        try {
            const response = await axiosInstance.get('/purchases/all');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchTotal: async () => {
        try {
            const response = await axiosInstance.get('/purchases/total');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
      updatePatient: async (id, payload) => {
        try {
            const response = await axiosInstance.put(`/purchases/edit/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
 };

export default purchaseService;
